import { render } from "./Hotspot25.vue?vue&type=template&id=3a624a2e&scoped=true&ts=true"
import script from "./Hotspot25.vue?vue&type=script&lang=ts"
export * from "./Hotspot25.vue?vue&type=script&lang=ts"

import "./Hotspot25.vue?vue&type=style&index=0&id=3a624a2e&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a624a2e"]])

export default __exports__